import { axiosInstance } from "./axios";
import useCustomMutation from "hooks/useCustomMutation";
import useCustomQuery from "hooks/useCustomQuery";
import { EOrder } from "components/SortOrder/typings";
import { IUser } from "dto/Admin/user";
import { IAddressBookVerificationListItem } from "dto/Admin/IAddressBookVerification";
import { IAddressBookVerificationNote } from "dto/Admin/IAddressBookVerificationNote";

const queryKeys = {
  getUsers: (sortProp?: string, sortOrder?: EOrder, text?: string) => [
    "adminService.getUsers",
    sortProp,
    sortOrder,
    text,
  ],
  getAddressBookVerificationDetails: (id: string) => [
    "adminService.getAddressBookVerificationDetails",
    id,
  ],
  getAddressBookVerificationNotes: (id: string) => [
    "adminService.getAddressBookVerificationNotes",
    id,
  ],
};

const getUsers = (
  sortProp?: string,
  sortOrder?: EOrder,
  text?: string
): Promise<{ data: IUser[] }> => {
  const query = new URLSearchParams(window.location.search);

  if (sortProp) {
    // url += `?FilterId=${FilterId}`;
    query.append("SortProp", sortProp);
  }

  if (sortOrder) {
    // url += `?FilterId=${FilterId}`;
    query.append("SortOrder", sortOrder);
  }

  if (text) {
    query.append("Text", text);
  }

  return axiosInstance.get(`/admin/users?${query}`);
};

const useGetUsers = (sortProp?: string, sortOrder?: EOrder, text?: string) => {
  return useCustomQuery(queryKeys.getUsers(sortProp, sortOrder, text), () =>
    getUsers(sortProp, sortOrder, text)
  );
};

export interface IAddAddressBookVerificationAttachment {
  ContactFormAddressBookVerificationId: string;
  Uri: string;
  Type: number;
}

export interface IAddAddressBookVerificationNote {
  ContactFormAddressBookVerificationId: string;
  Title: string;
  Content: string;
}

export interface IVerifyAddressBookVerification {
  ContactFormAddressBookVerificationId: string;
  Result?: string;
  Approve?: boolean;
  ToBeCompleted?: boolean;
  Reject?: boolean;
}

const addAddressBookVerificationAttachment = (
  payload: IAddAddressBookVerificationAttachment
) => {
  return axiosInstance.post(
    "/admin/addressbookverification/attachment",
    payload
  );
};

const useAddAddressBookVerificationAttachment = () => {
  return useCustomMutation(addAddressBookVerificationAttachment);
};

const addAddressBookVerificationNote = (
  payload: IAddAddressBookVerificationNote
): Promise<{ data: IAddressBookVerificationNote }> => {
  return axiosInstance.post("/admin/addressbookverification/note", payload);
};

const useAddAddressBookVerificationNote = () => {
  return useCustomMutation(addAddressBookVerificationNote);
};

const getAddressBookVerificationDetails = (
  id: string
): Promise<{ data: IAddressBookVerificationListItem }> => {
  const query = new URLSearchParams(window.location.search);
  query.append("Id", id);

  return axiosInstance.get(`/admin/addressbookverification?${query}`);
};

const useGetAddressBookVerificationDetails = (id: string) => {
  return useCustomQuery(queryKeys.getAddressBookVerificationDetails(id), () =>
    getAddressBookVerificationDetails(id)
  );
};

const getAddressBookVerificationNotes = (
  id: string
): Promise<{ data: IAddressBookVerificationNote[] }> => {
  const query = new URLSearchParams(window.location.search);
  query.append("Id", id);

  return axiosInstance.get(`/admin/addressbookverification/notes?${query}`);
};

const useGetAddressBookVerificationNotes = (id: string) => {
  return useCustomQuery(queryKeys.getAddressBookVerificationNotes(id), () =>
    getAddressBookVerificationNotes(id)
  );
};

const verifyAddressBookVerification = (
  payload: IVerifyAddressBookVerification
) => {
  return axiosInstance.post("/admin/addressbookverification/verify", payload);
};

const useVerifyAddressBookVerification = () => {
  return useCustomMutation(verifyAddressBookVerification);
};

export default {
  useGetUsers,
  useAddAddressBookVerificationAttachment,
  useAddAddressBookVerificationNote,
  useGetAddressBookVerificationDetails,
  useGetAddressBookVerificationNotes,
  useVerifyAddressBookVerification,
};
